type BrandLogoProps = {
  className?: string;
  compact?: boolean;
};

export function BrandLogo({ className = '', compact = false }: BrandLogoProps) {
  const sizes = compact
    ? '(max-width: 560px) 68px, (max-width: 980px) 82px, 74px'
    : '(max-width: 560px) 68px, (max-width: 980px) 82px, 92px';

  return (
    <a className={`brandLogo ${compact ? 'brandLogoCompact' : ''} ${className}`.trim()} href="/" aria-label="ProPickleball.nl home">
      <img
        src="/brand/propickleball-logo-128.png"
        srcSet="/brand/propickleball-logo-128.png 128w, /brand/propickleball-logo-256.png 256w, /brand/propickleball-logo-512.png 512w"
        sizes={sizes}
        alt=""
        width="512"
        height="512"
      />
      <span className="srOnly">ProPickleball.nl</span>
    </a>
  );
}
